/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssetVersion } from './assetVersion';
import { MakeBuyoutRights } from './makeBuyoutRights';
import { ProjectTaskRef } from './projectTaskRef';
import { CompanyBrandRef } from './companyBrandRef';
import { UsageRights } from './usageRights';
import { TeamRef } from './teamRef';
import { AssetDomain } from './assetDomain';
import { UserRef } from './userRef';
import { MainFileRef } from './mainFileRef';
import { CompanyRef } from './companyRef';
import { AssetVersionRef } from './assetVersionRef';
import { ProjectAssetRef } from './projectAssetRef';


export interface Asset { 
    createdAt: string;
    updatedAt?: string;
    createdBy?: string;
    updatedBy?: string;
    _id: string;
    accessKeys: Array<string>;
    assetType: Asset.AssetTypeEnum;
    idExternal?: string;
    name: string;
    status: Asset.StatusEnum;
    previousStatus?: Asset.PreviousStatusEnum;
    domains?: Array<AssetDomain>;
    agency: CompanyRef;
    client: CompanyRef;
    brand: CompanyBrandRef;
    projects?: Array<ProjectAssetRef>;
    subprojects?: Array<ProjectAssetRef>;
    teams?: Array<TeamRef>;
    tasks?: Array<ProjectTaskRef>;
    user?: UserRef;
    description?: string;
    notes?: string;
    clusterType?: string;
    expiryDate?: string;
    isExpired?: boolean;
    expiryNotificationSent?: string;
    plannedDeletion?: string;
    plannedDeletionUser?: string;
    tags?: Array<string>;
    /**
     * URL to load a preview image
     */
    previewUrl?: string;
    /**
     * basic file data stored inline
     */
    mainFile: MainFileRef;
    /**
     * The current, default file version
     */
    currentVersion?: AssetVersion;
    /**
     * All file versions as a reference
     */
    versions: Array<AssetVersionRef>;
    /**
     * Owner of the asset
     */
    owner?: string;
    customFields?: object;
    publishStartDate?: string;
    publishEndDate?: string;
    usageRights?: Array<UsageRights>;
    makeBuyoutRights?: Array<MakeBuyoutRights>;
    jobNumber?: string;
}
export namespace Asset {
    export type AssetTypeEnum = 'Image' | 'PDF' | 'Video' | 'Audio' | 'HTML Banner' | 'Powerpoint presentation' | 'ZIP' | 'Other';
    export const AssetTypeEnum = {
        Image: 'Image' as AssetTypeEnum,
        Pdf: 'PDF' as AssetTypeEnum,
        Video: 'Video' as AssetTypeEnum,
        Audio: 'Audio' as AssetTypeEnum,
        HtmlBanner: 'HTML Banner' as AssetTypeEnum,
        PowerpointPresentation: 'Powerpoint presentation' as AssetTypeEnum,
        Zip: 'ZIP' as AssetTypeEnum,
        Other: 'Other' as AssetTypeEnum
    };
    export type StatusEnum = 'approved' | 'rejected' | 'pending' | 'created' | 'expired' | 'uploaded' | 'awaiting_approval' | 'import' | 'failed' | 'archived' | 'draft';
    export const StatusEnum = {
        Approved: 'approved' as StatusEnum,
        Rejected: 'rejected' as StatusEnum,
        Pending: 'pending' as StatusEnum,
        Created: 'created' as StatusEnum,
        Expired: 'expired' as StatusEnum,
        Uploaded: 'uploaded' as StatusEnum,
        AwaitingApproval: 'awaiting_approval' as StatusEnum,
        Import: 'import' as StatusEnum,
        Failed: 'failed' as StatusEnum,
        Archived: 'archived' as StatusEnum,
        Draft: 'draft' as StatusEnum
    };
    export type PreviousStatusEnum = 'approved' | 'rejected' | 'pending' | 'created' | 'expired' | 'uploaded' | 'awaiting_approval' | 'import' | 'failed' | 'archived' | 'draft';
    export const PreviousStatusEnum = {
        Approved: 'approved' as PreviousStatusEnum,
        Rejected: 'rejected' as PreviousStatusEnum,
        Pending: 'pending' as PreviousStatusEnum,
        Created: 'created' as PreviousStatusEnum,
        Expired: 'expired' as PreviousStatusEnum,
        Uploaded: 'uploaded' as PreviousStatusEnum,
        AwaitingApproval: 'awaiting_approval' as PreviousStatusEnum,
        Import: 'import' as PreviousStatusEnum,
        Failed: 'failed' as PreviousStatusEnum,
        Archived: 'archived' as PreviousStatusEnum,
        Draft: 'draft' as PreviousStatusEnum
    };
}


